import {useCallback} from 'react';
import {useSendLogMutation} from '@app/redux/services/appLogService';
import {TLogMessageBody} from '@app/types';

export enum LogEvents {
  // HACK: Only events after authentication
  // Components
  ADDRESS_SEARCH_PRESS = 'ADDRESS_SEARCH_PRESS',

  // Registration Info
  EMAIL_CHANGE_CONFIRMATION_CODE_SEND_PRESS = 'EMAIL_CHANGE_CONFIRMATION_CODE_SEND_PRESS',
  ERROR_EMAIL_CHANGE_CONFIRMATION_CODE_SEND = 'ERROR_EMAIL_CHANGE_CONFIRMATION_CODE_SEND',
  EMAIL_CHANGE_CONFIRM_PRESS = 'EMAIL_CHANGE_CONFIRM_PRESS',
  ERROR_EMAIL_CHANGE_CONFIRM = 'ERROR_EMAIL_CHANGE_CONFIRM',
  PASSWORD_CHANGE_PRESS = 'PASSWORD_CHANGE_PRESS',
  ERROR_PASSWORD_CHANGE = 'ERROR_PASSWORD_CHANGE',

  // Audit History
  AUDIT_SEARCH_PRESS = 'AUDIT_SEARCH_PRESS',
  AUDIT_DATE_RANGE_SELECT = 'AUDIT_DATE_RANGE_SELECT',
  AUDIT_TABLE_PAGINATE = 'AUDIT_TABLE_PAGINATION',
  AUDIT_DETAIL_PRESS = 'AUDIT_DETAIL_PRESS',

  // Pharmacy List
  PHARMACY_RESEND_INVITATION_PRESS = 'PHARMACY_RESEND_INVITATION_PRESS',
  ERROR_PHARMACY_RESEND_INVITATION = 'ERROR_PHARMACY_RESEND_INVITATION',
  PHARMACY_DETAIL_PRESS = 'PHARMACY_DETAIL_PRESS',
  PHARMACY_TABLE_PAGINATE = 'PHARMACY_TABLE_PAGINATE',
  PHARMACY_EDIT_PRESS = 'PHARMACY_EDIT_PRESS',
  ERROR_PHARMACY_EDIT = 'ERROR_PHARMACY_EDIT',
  PHARMACY_REGISTER_PRESS = 'PHARMACY_REGISTER_PRESS',
  ERROR_PHARMACY_REGISTER = 'ERROR_PHARMACY_REGISTER',
  PHARMACY_INVITE_PRESS = 'PHARMACY_INVITE_PRESS',
  ERROR_PHARMACY_INVITE = 'ERROR_PHARMACY_INVITE',

  // Payment Info
  PAYMENT_REGISTER_PRESS = 'PAYMENT_REGISTER_PRESS',
  ERROR_PAYMENT_REGISTER = 'ERROR_PAYMENT_REGISTER',
  PAYMENT_EDIT_PRESS = 'PAYMENT_EDIT_PRESS',
  ERROR_PAYMENT_EDIT = 'ERROR_PAYMENT_EDIT',
  ERROR_PAYMENT_CARD = 'ERROR_PAYMENT_CARD',
  PAYMENT_UNSUBSCRIBE_BUTTON_PRESS = 'PAYMENT_UNSUBSCRIBE_BUTTON_PRESS',

  // Inventory List
  INVENTORY_LIST_TABLE_PAGINATE = 'INVENTORY_LIST_TABLE_PAGINATE',
  INVENTORY_LIST_DETAIL_PRESS = 'INVENTORY_LIST_DETAIL_PRESS',
  INVENTORY_LIST_SEARCH_PRESS = 'INVENTORY_LIST_SEARCH_PRESS',
  INVENTORY_LIST_DELETE_PRESS = 'INVENTORY_LIST_DELETE_PRESS',
  INVENTORY_DETAIL_EDIT_PRESS = 'INVENTORY_DETAIL_EDIT_PRESS',
  INVENTORY_LIST_BACK_PRESS = 'INVENTORY_LIST_BACK_PRESS',
  INVENTORY_LIST_MEMO_PRESS = 'INVENTORY_LIST_MEMO_PRESS',
  INVENTORY_REGISTER_ERROR = 'INVENTORY_REGISTER_ERROR',

  // Inquiry
  INQUIRY_SUBMIT_PRESS = 'INQUIRY_SUBMIT_PRESS',
  ERROR_INQUIRY_SUBMIT = 'ERROR_INQUIRY_SUBMIT',
  INQUIRY_FILE_UPLOAD = 'INQUIRY_FILE_UPLOAD',

  // ReseconList
  RECEIPT_COMPUTER_REGISTER_PRESS = 'RECEIPT_COMPUTER_REGISTER_PRESS',
  ERROR_RECEIPT_COMPUTER_REGISTER = 'ERROR_RECEIPT_COMPUTER_REGISTER',
  RECEIPT_COMPUTER_EDIT_PRESS = 'RECEIPT_COMPUTER_EDIT_PRESS',
  ERROR_RECEIPT_COMPUTER_EDIT = 'ERROR_RECEIPT_COMPUTER_EDIT',
  RECEIPT_COMPUTER_DELETE_PRESS = 'RECEIPT_COMPUTER_DELETE_PRESS',
  ERROR_RECEIPT_COMPUTER_DELETE = 'ERROR_RECEIPT_COMPUTER_DELETE',

  // Registration Info
  REGISTRATION_INFO_EDIT_PRESS = 'REGISTRATION_INFO_EDIT_PRESS',
  ERROR_REGISTRATION_INFO_EDIT = 'ERROR_REGISTRATION_INFO_EDIT',

  // User List
  STAFF_REGISTER_PRESS = 'STAFF_REGISTER_PRESS',
  ERROR_STAFF_REGISTER = 'ERROR_STAFF_REGISTER',
  STAFF_EDIT_PRESS = 'STAFF_EDIT_PRESS',
  ERROR_STAFF_EDIT = 'ERROR_STAFF_EDIT',
  STAFF_DELETE_PRESS = 'STAFF_DELETE_PRESS',
  ERROR_STAFF_DELETE = 'ERROR_STAFF_DELETE',

  // Unsubscribe
  UNSUBSCRIBE_PRESS = 'UNSUBSCRIBE_PRESS',
  INVENTORY_DELETE_PRESS = 'INVENTORY_DELETE_PRESS',
}

// TODO: Use external third-party remote logging service
export const useSendEvent = () => {
  const [sendLog] = useSendLogMutation();
  return useCallback(
    async (eventName: LogEvents, message?: TLogMessageBody) => {
      try {
        await sendLog({
          event_name: eventName,
          message,
        }).unwrap();
      } catch (error) {
        console.error(error);
      }
    },
    [sendLog],
  );
};
